export const getSelectedPreference = (prefName, preferences) => {
  return preferences && preferences.length > 0
    ? preferences.filter((pref) => {
        return pref.prefName === prefName;
      })
    : '';
};
